import FindRecipientPersonaType from '../store/schema/FindRecipientPersonaType';
import getDisplayNameFromFindRecipientPersonaType from '../utils/getDisplayNameFromFindRecipientPersonaType';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { observer } from 'mobx-react';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';
import { PersonaInitialsColor } from 'office-ui-fabric-react/lib/Persona';
import { ITheme } from '@uifabric/styling';
import { classNamesFunction } from '@uifabric/utilities';
import { getStyles } from './FindRecipient.styles';
import { FindRecipientStyleProps, FindRecipientStyles } from './FindRecipient.types';
import { getExtendedTheme } from 'owa-fabric-theme';

let classNamesUtil = require('classnames');

const getClassNames = classNamesFunction<FindRecipientStyleProps, FindRecipientStyles>();

export interface FindRecipientProps {
    findRecipient: FindRecipientPersonaType;
    isHighlighted: boolean;
    addRecipientAction: (recipientToAdd: FindRecipientPersonaType) => void;
    maskRecipientAction?: (recipientToMask: FindRecipientPersonaType) => void;
    theme?: ITheme;
}

@observer
export default class FindRecipient extends React.Component<FindRecipientProps, any> {
    private addSelectedRecipient = (evt: React.MouseEvent<any>) => {
        evt.preventDefault();
        this.props.addRecipientAction(this.props.findRecipient);
    };

    private maskRecipient = (evt: React.MouseEvent<any>) => {
        evt.preventDefault();
        evt.stopPropagation();
        if (this.props.maskRecipientAction) {
            this.props.maskRecipientAction(this.props.findRecipient);
        }
    };

    renderPersonaControl(
        isImplicitGroupPersona: boolean,
        recipientName?: string,
        recipientEmail?: string
    ) {
        let implicitGroupName = 'Implicit Group';
        return !isImplicitGroupPersona ? (
            <PersonaControl
                name={recipientName}
                emailAddress={recipientEmail}
                size={PersonaSize.size32}
                showPersonaDetails={false}
            />
        ) : (
            <PersonaControl
                name={implicitGroupName}
                emailAddress={recipientEmail}
                size={PersonaSize.size32}
                showPersonaDetails={false}
                initialsColor={PersonaInitialsColor.lightBlue}
            />
        );
    }

    renderImplicitGroupMemberPersonas(
        findRecipient: FindRecipientPersonaType,
        memberPersonaImageStyleClass: string
    ) {
        let memberPersonas = findRecipient.Members.map(member => {
            return (
                <div className={memberPersonaImageStyleClass} key={member.EmailAddress}>
                    <PersonaControl
                        key={member.EmailAddress}
                        name={member.Name}
                        emailAddress={member.EmailAddress}
                        size={PersonaSize.size16}
                        showPersonaDetails={false}
                    />
                </div>
            );
        });

        return memberPersonas;
    }

    renderPersonaControlLineTwo(
        personaLineTwoStyleClass: string,
        personaTextLineStyleClass: string,
        memberPersonaImageStyleClass: string,
        isImplicitGroupPersona: boolean,
        findRecipient: FindRecipientPersonaType,
        recipientEmail?: string
    ) {
        return !isImplicitGroupPersona ? (
            <span className={classNamesUtil(personaLineTwoStyleClass, personaTextLineStyleClass)}>
                {recipientEmail}
            </span>
        ) : (
            this.renderImplicitGroupMemberPersonas(findRecipient, memberPersonaImageStyleClass)
        );
    }

    render() {
        let {
            findRecipient,
            maskRecipientAction,
            isHighlighted,
            theme = getExtendedTheme(),
        } = this.props;
        const classNames = getClassNames(getStyles, { theme: theme, isHighlighted: isHighlighted });

        let recipientName = getDisplayNameFromFindRecipientPersonaType(findRecipient);
        let recipientEmail = findRecipient.EmailAddress.EmailAddress;

        let isImplicitGroupPersona = false;
        if (
            findRecipient.PersonaTypeString &&
            findRecipient.PersonaTypeString == 'ImplicitGroup' &&
            findRecipient.Members &&
            findRecipient.Members.length > 0
        ) {
            isImplicitGroupPersona = true;
        }

        let recipientMailboxType = findRecipient.EmailAddress.MailboxType;
        return (
            <div className={classNames.container} onClick={this.addSelectedRecipient}>
                <div className={classNames.personaContainer}>
                    <div className={classNames.personaImage}>
                        {this.renderPersonaControl(
                            isImplicitGroupPersona,
                            recipientName,
                            recipientEmail
                        )}
                    </div>
                    <div className={classNames.personaText}>
                        <span
                            className={classNamesUtil(
                                classNames.personaLineOne,
                                classNames.personaTextLine
                            )}>
                            {recipientName}
                            {recipientMailboxType == 'LinkedIn' && (
                                <Icon
                                    className={classNames.linkedInIcon}
                                    iconName={ControlIcons.LinkedInLogo}
                                />
                            )}
                        </span>
                        {this.renderPersonaControlLineTwo(
                            classNames.personaLineTwo,
                            classNames.personaTextLine,
                            classNames.memberPersonaImage,
                            isImplicitGroupPersona,
                            findRecipient,
                            recipientEmail
                        )}
                    </div>
                </div>
                {maskRecipientAction && (
                    <div className={classNames.maskRecipientButton} onClick={this.maskRecipient}>
                        <Icon className={classNames.cancelIcon} iconName={ControlIcons.Cancel} />
                    </div>
                )}
            </div>
        );
    }
}
